import { render, staticRenderFns } from "./SamChipSelect.vue?vue&type=template&id=1a20e2bc&scoped=true&"
import script from "./SamChipSelect.vue?vue&type=script&lang=js&"
export * from "./SamChipSelect.vue?vue&type=script&lang=js&"
import style0 from "./SamChipSelect.vue?vue&type=style&index=0&id=1a20e2bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a20e2bc",
  null
  
)

export default component.exports